<main class="p-7 space-y-8">

    <section class="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
            <p class="text-sm font-medium uppercase tracking-[0.18em] text-slate-500">Admin Dashboard</p>
            <h1 class="mt-2 text-3xl font-bold text-slate-900">Welcome back, Administrator</h1>
            <p class="mt-3 max-w-2xl text-sm text-slate-600">Monitor performance, recent content activity, and key website metrics in one place.</p>
        </div>
        <div class="flex flex-wrap gap-3">
            <button routerLink="/news" class="inline-flex items-center gap-2 rounded-2xl bg-blue-900 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-950/10 transition hover:bg-blue-800">
                <span class="material-symbols-outlined">add_circle</span>
                Add News Item
            </button>
            <!-- <button (click)="exportReport()" class="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
                <span class="material-symbols-outlined">bar_chart</span>
                Export Report
            </button> -->
        </div>
    </section>

    <section class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <article class="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <div class="flex items-center justify-between gap-3">
                <div>
                    <p class="text-sm font-semibold text-slate-500">News Items</p>
                    <p class="mt-3 text-3xl font-bold text-slate-900">{{ newsCount }}</p>
                </div>
                <div class="rounded-2xl bg-sky-100 p-3 text-sky-700">
                    <span class="material-symbols-outlined">article</span>
                </div>
            </div>
            <p class="mt-4 text-sm text-slate-500">+12% from last week</p>
        </article>

        <article class="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <div class="flex items-center justify-between gap-3">
                <div>
                    <p class="text-sm font-semibold text-slate-500">Categories</p>
                    <p class="mt-3 text-3xl font-bold text-slate-900">{{ categoriesCount }}</p>
                </div>
                <div class="rounded-2xl bg-emerald-100 p-3 text-emerald-700">
                    <span class="material-symbols-outlined">category</span>
                </div>
            </div>
            <p class="mt-4 text-sm text-slate-500">Updated daily</p>
        </article>

        <article class="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <div class="flex items-center justify-between gap-3">
                <div>
                    <p class="text-sm font-semibold text-slate-500">Published</p>
                    <p class="mt-3 text-3xl font-bold text-slate-900">{{ publishedCount }}</p>
                </div>
                <div class="rounded-2xl bg-violet-100 p-3 text-violet-700">
                    <span class="material-symbols-outlined">publish</span>
                </div>
            </div>
            <p class="mt-4 text-sm text-slate-500">72% of total content</p>
        </article>

        <article class="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <div class="flex items-center justify-between gap-3">
                <div>
                    <p class="text-sm font-semibold text-slate-500">Archived</p>
                    <p class="mt-3 text-3xl font-bold text-slate-900">{{ archivedCount }}</p>
                </div>
                <div class="rounded-2xl bg-orange-100 p-3 text-orange-700">
                    <span class="material-symbols-outlined">archive</span>
                </div>
            </div>
            <p class="mt-4 text-sm text-slate-500">Inactive content records</p>
        </article>
    </section>

    <section class="grid gap-12 w-screen -mx-12 px-7">
        <article class="w-full rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
            <div class="flex items-center justify-between gap-4">
                <div>
                    <p class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Latest news</p>
                    <h2 class="mt-2 text-2xl font-bold text-slate-900">Recent content updates</h2>
                </div>
                <button class="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">View all</button>
            </div>

            <div class="mt-6 overflow-hidden rounded-[24px] border border-slate-200">
                <table class="min-w-full divide-y divide-slate-200 text-left text-sm">
                    <thead class="bg-slate-50">
                        <tr>
                            <th class="px-4 py-3 font-semibold text-slate-500">Title</th>
                            <th class="px-4 py-3 font-semibold text-slate-500">Category</th>
                            <th class="px-4 py-3 font-semibold text-slate-500">Status</th>
                            <th class="px-4 py-3 font-semibold text-slate-500">Published</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200 bg-white">
                        <tr *ngFor="let item of recentActivities">
                            <td class="px-4 py-4 text-slate-900" style="width: 700px;">{{ item.title }}</td>
                            <td class="px-4 py-4 text-slate-600" style="width: 300px;">{{ item.category }}</td>
                            <td class="px-4 py-4">
                                <span [ngClass]="{
                                    'rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700': item.status === 'Published',
                                    'rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700': item.status === 'Draft',
                                    'rounded-full bg-slate-200 px-3 py-1 text-xs font-semibold text-slate-600': item.status === 'Archived'
                                }">{{ item.status }}</span>
                            </td>
                            <td class="px-4 py-4 text-slate-600">{{ item.date | date:'dd MMM yyyy' }}</td>
                        </tr>
                        <tr *ngIf="recentActivities.length === 0">
                            <td colspan="4" class="px-4 py-4 text-sm text-slate-500">No recent news</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </article>

        
    </section>

</main>
